import React from 'react';
import { Tooltip, Box } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

/**
 * ConfidentialIcon
 * Icono de candado para indicar si un cliente es confidential
 * Alineado con Stitch: Nexus Admin design system
 */
interface ConfidentialIconProps {
  isConfidential: boolean;
}

export const ConfidentialIcon: React.FC<ConfidentialIconProps> = ({ isConfidential }) => {
  if (isConfidential) {
    return (
      <Tooltip title="Confidential client">
        <Box
          component="span"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#855300', // secondary color
          }}
        >
          <LockIcon sx={{ fontSize: 18 }} />
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Public client">
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          color: '#737688', // outline color
        }}
      >
        <LockIcon sx={{ fontSize: 18 }} />
      </Box>
    </Tooltip>
  );
};
